<template>
  <el-checkbox v-model="checked" border size="small">
    Voodoo only <span> ({{ nbVoodooGames }})</span>
  </el-checkbox>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  name: 'PublisherComponent',
  props: [
    'nbVoodooGames',
  ],
  data() {
    return {
      checked: this.isPublisherVoodoo(),
    };
  },
  methods: {
    ...mapMutations({
      setFilterPublisher: 'game/setFilterPublisher',
    }),
    isPublisherVoodoo(currentPublisher = null) {
      if (currentPublisher === null) {
        // eslint-disable-next-line no-param-reassign
        currentPublisher = this.$route.params.publisher;
      }

      return currentPublisher === 'voodoo';
    },
  },
  watch: {
    checked(newVal) {
      const publisherName = newVal ? 'voodoo' : null;

      this.$router.push({
        name: 'home',
        params: {
          ...this.$route.params,
          publisher: publisherName,
        },
      }).catch(() => {});

      this.setFilterPublisher(publisherName);
    },
    $route(to, from) {
      if (to.params.publisher !== from.params.publisher) {
        this.checked = this.isPublisherVoodoo(to.params.publisher);
      }
    },
  },
};
</script>

<style scoped>

</style>
